import type { Theme } from '@mui/material';
import Grid from '@mui/material/Grid';
import type { StyleRules, WithStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import type {
  EditPropsMappedFromDispatch,
  EditPropsMappedFromState
} from '../../containers/projectDraft/EditContainer';

import RootContainer from '../../containers/projectDraft/RootContainer';
import SideStepperContainer from '../../containers/projectDraft/SideStepperContainer';
import SyncStatusContainer from '../../containers/projectDraft/SyncStatusContainer';

const styles = (theme: Theme): StyleRules =>
  createStyles({
    root: {},
    contents: {
      paddingLeft: 200,
      paddingBottom: theme.spacing(13)
    }
  });

type PathParams = {
  urlCode?: string;
};

type EditProps = EditPropsMappedFromState &
  EditPropsMappedFromDispatch &
  WithStyles<typeof styles>;

const Edit: React.FC<EditProps> = ({
  classes,
  urlCode,
  getProjectDrafts,
  updateProjectDraftIfNeeded,
  initilizeProjectDraftSyncStatus,
  excludeInvalidProjectDraftData
}) => {
  const navigate = useNavigate();
  const params = useParams<PathParams>();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let intervalID = 0;
    if (params.urlCode) {
      getProjectDrafts(params.urlCode, navigate)
        .then(() => {
          setLoaded(true);
          intervalID = window.setInterval(updateProjectDraftIfNeeded, 5000);

          excludeInvalidProjectDraftData();
        })
        .catch(() => {});
    }

    return () => {
      cleanup(intervalID);
    };
  }, [urlCode]);

  const cleanup = (intervalID: number): void => {
    updateProjectDraftIfNeeded().finally(() => {
      initilizeProjectDraftSyncStatus();
    });
    window.clearInterval(intervalID!);
  };

  return !loaded ? null : (
    <Grid
      container
      direction="column"
      justifyContent="center"
      className={classes.root}
    >
      <SideStepperContainer />
      <Grid container justifyContent="center" className={classes.contents}>
        <Grid container justifyContent="flex-end" sx={{ mt: 2 }}>
          <SyncStatusContainer />
        </Grid>
        {/* ステップに基づくコンテンツの表示 */}
        <RootContainer />
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(Edit);
